<div class="d-flex justify-content-between px-3">
  <button *ngFor="let target of targetInfo;let i = index" class="h-auto btn-design medium w-100 cursor-pointer" [ngClass]="{'mr-2': (i === numbers.ZERO && targetInfo && targetInfo.length > numbers.ONE),
    'filled': target.ctaType?.toLowerCase() === 'primary', 'outline': target.ctaType?.toLowerCase() !== 'primary'}"
    (click)="ctaTarget(target)">
    {{target.text}}
  </button>
</div>
